<template>
  <div class="main-container">
    <div class="bread" v-if="!!$route.query.recommend">
      <router-link :to="{ name: 'Index' }">首页</router-link>
      <span class="slash">/</span>
      <span class="current">{{ $route.query.title }}</span>
    </div>
    <SearchKeyWords></SearchKeyWords>
    <Classify
      class="classify"
      :class="{
        'classify-top': !$route.query.recommend && !$route.query.keywords,
      }"
      :items="classifyItems"
      @change="onClassifyChange"
    ></Classify>
    <ListSort v-model="sort"></ListSort>
    <List
      class="list"
      ref="list"
      url="/api/app/classpack/packlist/index"
      :search="search"
      :limit="16"
      :alwaysShowPager="true"
    >
      <template v-slot="{ list }">
        <div class="clearfix" v-if="list.length">
          <PeriodsItem v-for="item in list" :key="item.id" :item="item"></PeriodsItem>
        </div>
        <EmptyNew v-if="list.length == 0" class="empty" title="暂无课时包！" />
      </template>
    </List>
  </div>
</template>
<script>
import List from '@/components/List.vue';
import PeriodsItem from '@/modules/stu/components/periods/PeriodsItem.vue';
import Classify from '../../components/Classify.vue';
import { PeriodsType, TeachingType } from '@/utils/enums';
import ListSort from '@/modules/stu/components/ListSort.vue';
import SearchKeyWords from '@/modules/stu/components/SearchKeyWords.vue';
import EmptyNew from '@/components/EmptyNew.vue';

const signTypeOptions = PeriodsType.getOptions(true).map((t) => {
  return { id: t.key, name: t.value };
});
const teachingTypeOptions = TeachingType.getOptions(true).map((t) => {
  return { id: t.key, name: t.value };
});

export default {
  name: 'Periods',
  components: {
    List,
    PeriodsItem,
    Classify,
    ListSort,
    SearchKeyWords,
    EmptyNew,
  },
  data() {
    return {
      sign_type: 0,
      teaching_type: 0,
      course_classify_id: 0,
      grade_id: 0,
      subject_id: 0,
      sort: 0,
      screen: {},
    };
  },
  computed: {
    classifyItems() {
      let items = [];
      items.push({
        id: 'sign_type',
        name: '授课类型',
        value: { item: this.sign_type },
        children: signTypeOptions,
      });
      items.push({
        id: 'teaching_type',
        name: '上课方式',
        value: { item: this.teaching_type },
        children: teachingTypeOptions,
      });
      if (this.screen.courseClassify) {
        items.push({
          id: 'course_classify_id',
          name: '分类',
          value: { item: this.course_classify_id },
          children: [
            { id: 0, name: '全部' },
            ...this.screen.courseClassify.map((t) => {
              return { id: t.id, name: t.classify_name };
            }),
          ],
        });
      }
      if (this.screen.grades) {
        items.push({
          id: 'grade_id',
          name: '年级',
          value: { item: this.grade_id },
          children: [{ id: 0, name: '全部' }, ...this.screen.grades],
        });
      }
      if (this.screen.subjects) {
        items.push({
          id: 'subject_id',
          name: '科目',
          value: { item: this.subject_id },
          children: [
            { id: 0, name: '全部' },
            ...this.screen.subjects.map((t) => {
              return { id: t.id, name: t.sub_name };
            }),
          ],
        });
      }
      return items;
    },
    search() {
      return {
        sign_type: this.sign_type,
        teaching_type: this.teaching_type,
        course_classify_id: this.course_classify_id,
        grade_id: this.grade_id,
        subject_id: this.subject_id,
        order_by: this.sort,
        recommend: this.$route.query.recommend,
        keywords: this.$route.query.keywords,
      };
    },
  },
  watch: {
    $route() {
      this.$refs.list.searchRefresh();
    },
    sort() {
      this.$refs.list.searchRefresh();
    },
  },
  async created() {
    this.screen = await this.$http.get('/api/app/classpack/screen');
  },
  methods: {
    async onClassifyChange({ id, value }) {
      this[id] = value.item;
      this.$refs.list.searchRefresh();
    },
  },
};
</script>
<style lang="scss" scoped>
.classify {
  ::v-deep {
    #sign_type_1 {
      margin-right: 36px;
    }
  }
}
.classify-top {
  margin-top: 24px;
}
.select-tab-wrap {
  margin-top: 30px;
}
.list {
  ::v-deep {
    .pager {
      margin-top: 10px !important;
    }
  }
}
.main-container {
  padding-bottom: 46px;
}
.empty {
  margin-bottom: 50px;
}
</style>
